import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Assets } from "utils/Assets";
import { Icons } from "utils/Icons";
import { useTranslation } from "react-i18next";
import { useListTeamQuery } from "../../redux/features/myplan/planApi";
import { file_url } from "constant/url";
import { useDispatch, useSelector } from "react-redux";
import { teamData } from "../../redux/features/myplan/planSlice";
import { Helmet } from "react-helmet";
import { Modal } from "antd";
import CustomButton from "components/CustomButton";
import CreateTeamModal from "components/CreateTeamModal";
import DeleteModal from "components/DeleteModal";
import NoDataPage from "pages/nodata/NoDataPage";
import moment from "moment";


const MyPlan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [teamModal, setTeamModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [messageModal, setMessageModal] = useState(false);
    const [teamDetail, setTeamDetail] = useState(null);
    // const [cachedData, setCachedData] = useState(null);
    const { data: teams } = useListTeamQuery();
    const userDetail = useSelector(state => state?.common?.user_data);

    const handleEditTeam = (item, type) => {
        setTeamDetail(item)
        if (type == 'edit') {
            setTeamModal(true)
        } else {
            setDeleteModal(true)
        }
    };

    // Check localStorage for cached data
    // useEffect(() => {
    //     const cachedTeams = localStorage.getItem('teamList');
    //     if (cachedTeams) {
    //         setCachedData(JSON.parse(cachedTeams));
    //     }
    // }, []);

    // useEffect(() => {
    //     if (teams?.data) {
    //         // Cache the data if new data comes in
    //         localStorage.setItem('teamList', JSON.stringify(teams.data));
    //         setCachedData(teams.data);
    //     }
    // }, [teams]);

    // const teamList = cachedData || teams?.data;
    const teamList = teams?.data;

    return (
        <>
            <Helmet>
                <title>My Plan - Premier Futbol Institute</title>
                <meta name="description" content="Manage your football teams and training plans efficiently." />
                <meta property="og:title" content="My Plan - Premier Futbol Institute" />
                <meta property="og:description" content="Manage your football teams and training plans efficiently." />
                <meta property="og:image" content="https://d3rzktdbhpm4zh.cloudfront.net/web_static_media/drill.png" />
                <meta property="og:url" content="https://dev.d2amudylbskc3c.amplifyapp.com/my-plan" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="plan_content_height">
                <div className="row g-3 g-md-4 g-lg-4">
                    {teamList?.length > 0 ? teamList?.map((item) => {
                        return (
                            <div role="button" tabIndex={0} onKeyDown={() => { userDetail?.subscription_expired && setMessageModal(true) }} onClick={() => { userDetail?.subscription_expired && setMessageModal(true) }} className="col-12 col-lg-6 position-relative" key={item?._id}>
                                {userDetail?.subscription_expired && <div className="lock-overlay">
                                    <img src={Assets.lockIcon} alt="Locked" width={60} />
                                </div>}
                                <div className="common_card" style={{ filter: userDetail?.subscription_expired ? 'blur(3px)' : 'none' }}>
                                    <div className="d-flex align-items-center gap-3 w-100" role="button" tabIndex={0} onKeyDown={() => '_'} onClick={() => { 
                                        if (!userDetail?.subscription_expired) { 
                                            navigate(`/session/${item?._id}`); 
                                            dispatch(teamData(item)); 
                                        }
                                    }}>
                                        <div
                                            className="team_image"
                                            style={{
                                                background: item?.team_image ? `url(${file_url}${item?.team_image}) center no-repeat` : `url(${Assets.darkBallLogo}) center no-repeat`,
                                                backgroundSize: 'cover',
                                            }}
                                        />
                                        <div className="text_content">
                                            <h1 className="medium_font">{item?.team_name}</h1>
                                            <h2 className="small_font text-black">{t("header.plan")}: {item?.plan_id?.plan_name}</h2>
                                            <h6 className="small_font" style={{ color: 'var(--text-gray)' }}>{item?.plan_id?.plan_description}</h6>
                                        </div>
                                    </div>
                                    <div className="action_div">
                                        <Icons.IoIosArrowForward size={25} onClick={() => { 
                                            if (!userDetail?.subscription_expired) { 
                                                navigate(`/session/${item?._id}`); 
                                                dispatch(teamData(item)); 
                                            }
                                        }} />
                                        <div className="d-flex gap-3">
                                            <span role="button" tabIndex={0} onKeyDown={() => ''} onClick={() => { !userDetail?.subscription_expired && handleEditTeam(item, 'edit') }} className="route_icon" style={{ background: `var(--yellow-normal)` }}>
                                                <img src={Assets.editIcon} alt="" width='20' />
                                            </span>
                                            <span role="button" tabIndex={0} onKeyDown={() => ''} onClick={() => { !userDetail?.subscription_expired && handleEditTeam(item, 'del') }} className="route_icon" style={{ background: `var(--pink-bad)` }}>
                                                <img src={Assets.deleteIcon} alt="" width='20' />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }) :
                        <NoDataPage img={Assets.noTeamImg} />
                    }
                </div>
            </div>
            <div className="d-block d-sm-none d-md-none d-lg-none mt-4 fixed_button">
                <div className="btn_border border-black">
                    <CustomButton
                        onClick={() => setTeamModal(true)}
                        style={{ background: `var(--green)`, color: `var(--black)`, width: '100%' }}
                    >
                        {t("buttons.create_new_team")}
                    </CustomButton>
                </div>
            </div>

            {/* Team modal */}
            <CreateTeamModal teamModal={teamModal} setTeamModal={setTeamModal} teamDetail={teamDetail} setTeamDetail={setTeamDetail} />
            {/* Delete modal */}
            <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} teamDetail={teamDetail} />
            {/* Subscription expired modal */}
            <Modal
                title={<img src={Assets.darkLogo} alt="" width={180} />}
                open={messageModal}
                onCancel={() => setMessageModal(false)}
                closeIcon={<img src={Assets.closeIcon} alt="" />}
                centered
                footer=''
            >
                <div className="text-center p-4">
                    {/* Lock Icon with Circle */}
                    <div className="bg-light rounded-circle d-inline-flex p-4 mb-4">
                        <img src={Assets.lockIcon} alt="Subscription Expired" width={60} className="text-warning" />
                    </div>

                    {/* Title */}
                    <h4 className="fw-bold text-dark mb-3">Access Restricted</h4>

                    {/* Message */}
                    <p className="text-muted mb-3">
                        <small>
                            Your subscription plan has ended. Renew your subscription to unlock all features and continue using the platform without interruptions.
                        </small>
                    </p>

                    {/* Warning Alert */}
                    <div className="alert alert-warning py-2 mb-4">
                        <small className="fw-medium">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            Subscription expired on {moment(userDetail?.subscription_detail?.current_period_end * 1000).format('ll')}
                        </small>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-grid gap-2">
                        <button
                            className="btn btn-warning text-white fw-medium py-2"
                            onClick={() => {
                                navigate(`/settings?tab=${3}`);
                                setMessageModal(false);
                            }}
                        >
                            Upgrade Plan Now
                        </button>
                        <button
                            className="btn btn-outline-secondary py-2"
                            onClick={() => setMessageModal(false)}
                        >
                            Maybe Later
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default MyPlan;
